
import "../../css/service3.css";
import servicesData from "../../json/servicesData.json";


function ServiceSection3() {
    const { sectionTitle, services } = servicesData;

    return (
        <div className="services" id="servicios">
            <div className="container-fluid">
                <div className="section-title">
                    <h2>{sectionTitle.title}</h2>
                    <p>{sectionTitle.subtitle}</p>
                </div>

                <div className="row">
                    {services.map((service) => (
                        <a href={service.path} className="col-lg-4 col-md-6 box-link" target="_blank" rel="noopener noreferrer" key={service.id}>
                            <div className="box">
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                                <ul className="service-list">
                                    {service.items.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ServiceSection3;